/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon16Solid = forwardRef('AttachPaperclipIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.016 2.626a3.873 3.873 0 0 1 5.477 5.477L9.607 12.99a5.36 5.36 0 1 1-7.58-7.58l3.428-3.427a.9.9 0 0 1 1.273 1.273L3.301 6.683a3.56 3.56 0 1 0 5.034 5.034L13.22 6.83a2.073 2.073 0 1 0-2.932-2.932L5.318 8.87a.587.587 0 1 0 .83.83L9.66 6.187a.9.9 0 1 1 1.272 1.273L7.42 10.972a2.387 2.387 0 0 1-3.375-3.375l4.971-4.97Z" })));
});
